import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from 'components/Navbar/Navbar';
import HomePage from 'pages/HomePage';
import Questionnaires from 'pages/Questionnaires';
import NotFoundPage from 'pages/NotFoundPage';
import SuccessPage from 'pages/SuccessPage';
import { Box } from '@chakra-ui/react';
import { SessionProvider } from 'context/SessionContext';
import { ExtraQuestionsDataProvider } from 'context/ExtraQuestionsContext';
import { UserProvider } from 'context/UserContext';

const App: React.FC = () => {
  return (
    <SessionProvider>
      <UserProvider>
        <ExtraQuestionsDataProvider>
          <Box>
            <Navbar title="Questionário Médico" />
            <Router>
              <Switch>
                <Route exact path="/" component={HomePage} />
                <Route exact path="/questionarios" component={Questionnaires} />
                <Route exact path="/success" component={SuccessPage} />
                <Route exact path="/not-found" component={NotFoundPage} />
              </Switch>
            </Router>
          </Box>
        </ExtraQuestionsDataProvider>
      </UserProvider>
    </SessionProvider>
  );
};

export default App;
